import { Component, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NrToggleSwitchComponent } from 'src/app/shared/components/nr-toggle-switch/nr-toggle-switch.component';
import { SubscriptionPreference } from '../../Interfaces/profile';

@Component({
  selector: 'email-subscription',
  imports: [FormsModule, CommonModule, ReactiveFormsModule, NrToggleSwitchComponent],
  templateUrl: './email-subscription.component.html',
  styleUrl: './email-subscription.component.scss',
})
export class EmailSubscriptionComponent implements OnInit {
  @Input() subscriptions!: SubscriptionPreference[];
  @Input() emailSubscriptionsForm!: FormArray;
  @Output() emailPreferenceChange = new EventEmitter<SubscriptionPreference[]>(); // Emit updated payload to parent

  private readonly fb = inject(FormBuilder);

  ngOnInit() {
    this.emailSubscriptionsForm = this.fb.array([]);
    this.createSubscriptionForm();
  }

  createSubscriptionForm(): void {
    this.subscriptions.forEach(({ subscriptionId, subDescription, isActive }) => {
      const subscriptionGroup = this.fb.group({
        subscriptionId: [subscriptionId],
        subDescription: [subDescription],
        isActive: [isActive],
      });
      this.emailSubscriptionsForm.push(subscriptionGroup);
    });
  }

  getIsActiveControl(idx: number): FormControl {
    const subscriptionGroup = this.emailSubscriptionsForm.at(idx) as FormGroup;
    return subscriptionGroup.get('isActive') as FormControl;
  }
  onEmailSubscriptionChange(): void {
    this.emailPreferenceChange.emit(this.emailSubscriptionsForm.value);
  }
}
